import React from 'react';

import { Collapse } from 'antd';
import { Box, Button, Container, Grid, Stack, Typography, styled } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Iconify from '../Iconify';
import CustomButton from '../CustomButton';

const { Panel } = Collapse;

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={2} square {...props} />)(({ theme }) => ({
  border: '1px solid #f2f2f2',
  borderRadius: '10px',
  marginBottom: 20,
  padding:10,
  '&:not(:last-child)': {
    borderBottom: 1,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
  backgroundColor: 'transparent',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function AppFaq() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div id="faq" className="faqBlock1 ">
      <div className="">
        <div>
          <Stack paddingX={{ xs: 0, sm: 10, md: 20, lg: 30, xl: 40 }}>
            <Typography textAlign="center" variant="h5" sx={{ color: 'orangered' }}>
              FAQ
            </Typography>
            <Typography textAlign="center" variant="h2" >
              Questions <span style={{ color: '#5E17EB' }}>fréquemments posées</span>
            </Typography>
            <Typography textAlign="center" color="text.secondary" fontSize={20}>
              Tout ce que vous devez savoir pour commencer avec Choptonticket.
            </Typography>
          </Stack>

        </div>
        <Container>
          <Grid container paddingTop={8} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Grid item xs={12} sm={10}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20}>
                    Votre Solution est-elle sécurisée ?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    Choptonticket garantit une solution à la fois sûre et rassurante. Nous accordons une attention
                    particulière à la gestion sécurisée de l'accès, à la séparation des données, ainsi qu'à la
                    sauvegarde et à la redondance des services pour assurer la protection optimale de vos informations.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20}>
                    A qui s'adresse nos service ?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    Choptontiket est une solution en libre-service, offrant ainsi la possibilité de maintenir un
                    contrôle total sur votre événement et de personnaliser vos billetteries de manière optimale. Cette
                    solution est adoptée par divers acteurs tels que des associations, des entreprises, des
                    indépendants, des collectivités et des particuliers, couvrant ainsi un large éventail de secteurs et
                    d'applications.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20} >
                    Puis-je proposer des réductions ou des codes de promotions à mes participants
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    Les codes promotionnels représentent une stratégie efficace pour stimuler les achats. Proposez des
                    réductions aux nouveaux inscrits, utilisez-les pour évaluer l'impact de vos initiatives
                    promotionnelles, ou offrez-les à des segments spécifiques de clients pour mesurer la portée de vos
                    événements.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20}>

                    Pourrais-je facilement récupérer la liste de mes ventes après la fin de mon événement ?

                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    Effectivement vous avez la possibilité d'exporter vos données si vous le souhaitez. Cependant
                    pourquoi se limiter à l'exportation quand vous pouvez obtenir plus avec Choptonticket ? Nous mettons
                    à votre disposition un outil CRM qui vous permet d'organiser des campagnes d'e-mails et des
                    notifications push (pour IOS et Android) directement depuis la plateforme. De plus, vous avez une
                    vue d'ensemble complète de tous les participants de tous vos événements organisés avec
                    Choptonticket.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20}>
                    En cas d'annulation, que se passe-t-il ?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    En cas d'annulation d'un événement, Choptonticket offre une solution facile et efficace pour le
                    remboursement des participants. Les organisateurs ont la possibilité d'utiliser notre outil dédié au
                    remboursement, qui simplifie le processus en quelques étapes. Les fonds peuvent être restitués aux
                    clients de manière transparente, assurant ainsi une gestion fluide des remboursements en cas
                    d'annulation d'un événement.Notre équipe de support est également disponible pour accompagner les
                    organisateurs tout au long de ce processus, garantissant une expérience satisfaisante pour tous les
                    parties impliquées.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
                  <Typography color="text.primary" fontWeight={800} fontSize={20}>
                    Comment me tenir informé des billets vendu ?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" fontSize={18}>
                    Choptonticket met a votre disposition un tableau de bord vous permettant de suivre en temps réel vos
                    ventes et accéder à des informations statistiques. Vous recevrez egalement un rapport sur le nombre
                    de billet vendu de manière hebdomadaire
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>

          

        </Container>
      </div>
    </div>
  );
}

export default AppFaq;
